import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule, MatAutocompleteModule, MatCheckboxModule, MatButtonModule, MatFormFieldModule, MatTabsModule, MatSelectModule, MatDatepickerModule, MatIconModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TravelReimbursementService } from './services/travel-reimbursement.service';
import { TravelReimbursementListComponent } from './components/travel-reimbursement-list/travel-reimbursement-list.component';
import { TravelReimbursementAddComponent } from './components/travel-reimbursement-add/travel-reimbursement-add.component';
import { TravelReimbursementCancelComponent } from './components/travel-reimbursement-cancel/travel-reimbursement-cancel.component';
import { TravelReimbursementApproveListComponent } from './components/travel-reimbursement-approve-list/travel-reimbursement-approve-list.component';
import { TravelReimbursementViewComponent } from './components/travel-reimbursement-view/travel-reimbursement-view.component';
import { TravelReimbursementApproverComponent } from './components/travel-reimbursement-approver/travel-reimbursement-approver.component';
import { TravelReimbursementApproverViewComponent } from './components/travel-reimbursement-approver-view/travel-reimbursement-approver-view.component';


@NgModule({
  declarations: [
    TravelReimbursementAddComponent,
    TravelReimbursementCancelComponent,
    TravelReimbursementApproveListComponent,
    TravelReimbursementViewComponent,
    TravelReimbursementListComponent,
    TravelReimbursementApproverComponent,
    TravelReimbursementApproverViewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTabsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule
  ],
  providers:[    
    TravelReimbursementService
  ],
  entryComponents:[
    TravelReimbursementAddComponent,
    TravelReimbursementCancelComponent,
    TravelReimbursementApproveListComponent,
    TravelReimbursementViewComponent,
    TravelReimbursementApproverViewComponent
  ]
})
export class TravelReimbursementModule { }
